import React, { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import {
  homeOutline,
  informationCircleOutline,
  shieldCheckmarkOutline,
} from "ionicons/icons";

import {
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonText,
  IonToolbar,
} from "@ionic/react";
import { useProjectsStore } from "@/core/stores/projects.store";

type Props = {};

const NAV_ITEMS = [
  {
    label: "מקומות קרובים",
    route: "/nearby",
    icon: homeOutline,
  },
  {
    label: "אודות",
    route: "/about",
    icon: informationCircleOutline,
  },
];

export function MainMenu({}: Props) {
  const [version, setVersion] = useState<string | null>(null);
  const currentProject = useProjectsStore((state) => state.currentProject);

  useEffect(() => {
    App.getInfo()
      .then((info) => setVersion(info.version))
      .catch(() => setVersion(null));
  }, []);

  return (
    <IonMenu contentId="main-content">
      <IonHeader>
        <IonToolbar
          style={
            {
              "--background": "var(--app-color-brand-dark)",
              "--border-width": "0",
            } as React.CSSProperties
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingBlock: "var(--app-space-lg)",
              gap: "var(--app-space-sm)",
            }}
          >
            <div
              style={{
                width: "160px",
                height: "160px",
                borderRadius: "var(--app-radius-md)",
                background: "rgba(255,255,255,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "var(--app-space-xs)",
              }}
            >
              <img
                src="/icon-192.png"
                alt="לוגו האפליקציה"
                style={{
                  height: "144px",
                  width: "144px",
                  borderRadius: "var(--app-radius-sm)",
                  objectFit: "contain",
                }}
              />
            </div>

            <IonText
              style={{
                color: "var(--ion-color-secondary)",
                fontSize: "1rem",
                fontWeight: 700,
                letterSpacing: 0,
              }}
            >
              BeTogether
            </IonText>

            <IonText
              style={{
                color: "rgba(255,255,255,0.6)",
                fontSize: "0.8125rem",
                fontWeight: 400,
                letterSpacing: 0,
                textAlign: "center",
                lineHeight: 1.5,
              }}
            >
              מציאת מקלטים קרובים
              <br />
              לביטחון ושלווה
            </IonText>
          </div>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonList
          lines="none"
          style={{ paddingTop: "var(--app-space-md)", paddingBottom: 0 }}
        >
          {NAV_ITEMS.map(({ label, route, icon }, index) => {
            // Replace first menu item label with current project name if available
            const displayLabel =
              index === 0 && currentProject?.name
                ? currentProject.name
                : label;
            return (
              <IonMenuToggle key={route}>
                <IonItem
                  routerLink={route}
                  detail={false}
                  style={
                    {
                      "--padding-start": "var(--app-space-lg)",
                      "--inner-padding-end": "var(--app-space-lg)",
                      "--min-height": "52px",
                      marginBottom: "var(--app-space-xs)",
                    } as React.CSSProperties
                  }
                >
                  <IonIcon
                    slot="start"
                    icon={icon}
                    color="primary"
                    style={{
                      fontSize: "1.25rem",
                      marginInlineEnd: "var(--app-space-md)",
                    }}
                  />
                  <IonLabel
                    style={{
                      fontSize: "0.9375rem",
                      fontWeight: 600,
                      letterSpacing: 0,
                    }}
                  >
                    {displayLabel}
                  </IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}
        </IonList>
      </IonContent>

      {Capacitor.isNativePlatform() && (
        <IonFooter>
          <IonToolbar>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingBlock: "var(--app-space-md)",
                gap: "var(--app-space-xs)",
              }}
            >
              <IonIcon
                icon={shieldCheckmarkOutline}
                style={{ fontSize: "0.875rem", color: "var(--ion-color-medium)" }}
              />
              <IonText color="medium" style={{ fontSize: "0.8125rem" }}>
                {version ? `גרסה ${version}` : "NDN Locations"}
              </IonText>
            </div>
          </IonToolbar>
        </IonFooter>
      )}
    </IonMenu>
  );
}
